import { render, staticRenderFns } from "./MatchHeadstartAndHSGSRPLikelyReferral.vue?vue&type=template&id=b7a19674&"
import script from "./MatchHeadstartAndHSGSRPLikelyReferral.vue?vue&type=script&lang=ts&"
export * from "./MatchHeadstartAndHSGSRPLikelyReferral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports